import { config } from "../../config";
import RequestError from "../../RequestError";
import { RegisterObject } from "../../types/model";
import { getInfoFromJwt, formatUserData, getAuthToken } from "./utils";

type FetchConfigType = {
  headers: {
    [key: string]: any;
  };
};

function getFetchConfig() {
  const fetchConfig: FetchConfigType = { headers: {} };

  const bearerToken = getAuthToken();
  if (bearerToken) {
    fetchConfig.headers["X-USER-AUTH"] = `Bearer ${bearerToken}`;
  }

  return fetchConfig;
}

export async function getStores() {
  const country = config.storeMarketOverride || config.country;
  const res = await fetch(
    `${config.storeEventApiHost}/api/v1.0/stores?countryCode=${country}`
  );

  if (!res.ok) {
    throw new RequestError(res.status, res.statusText);
  }

  const stores = await res.json();

  return stores;
}

export async function getEvents() {
  const res = await fetch(
    `${config.storeEventApiHost}/api/v1.0/events?countryCode=${config.country}`,
    getFetchConfig()
  );
  if (!res.ok) {
    throw new RequestError(res.status, res.statusText);
  }
  const events = await res.json();
  return events;
}

export async function getEvent(eventId: string) {
  const res = await fetch(
    `${config.storeEventApiHost}/api/v1.0/events/${eventId}`,
    getFetchConfig()
  );
  if (!res.ok) {
    throw new RequestError(res.status, res.statusText);
  }
  const event = await res.json();
  return event;
}

export async function registerConsumer(
  eventId: string,
  timeSlotId: string,
  data: RegisterObject
) {
  const fetchConfig = getFetchConfig();

  const res = await fetch(
    `${config.storeEventApiHost}/api/v1.0/events/${eventId}/timeslots/${timeSlotId}/registrations`,
    {
      ...fetchConfig,
      method: "PUT",
      body: JSON.stringify(data),
      headers: {
        ...fetchConfig.headers,
        "Content-Type": "application/json",
      },
    }
  );

  if (!res.ok) {
    throw new RequestError(res.status, res.statusText);
  }
}

export async function authenticate() {
  const { userInfoApi } = config;
  const bearerToken = getAuthToken();
  const { partyUId } = getInfoFromJwt(bearerToken);
  let headers = { [config.userInfoApiAuthHeader]: `Bearer ${bearerToken}` };
  if (config.userInfoApiClientId) {
    headers["x-client-id"] = config.userInfoApiClientId;
  }

  const res = await fetch(`${userInfoApi}/${partyUId}`, {
    headers,
  });

  if (!res.ok) {
    throw new RequestError(res.status, res.statusText);
  }

  const userData = await res.json();

  return formatUserData(userData);
}
